module.exports = __webpack_public_path__ + "media/images/web/logo-g-trans-763189fe078215691ea601338f86f4c1.png";